import { Controller } from 'stimulus';

// Fires a live community refresh (POST refresh_communities) as soon as the EHR
// edit page loads, so the admin always sees the current list. The endpoint
// caches the result as EhrCommunity rows and streams the refreshed multi-select
// back into #community_list. Failures are non-fatal: the server already rendered
// the last-known cached communities, so we leave them in place and report the
// failure to appsignal — a refresh only fires on an admin opening the edit page,
// so the volume is low enough to be worth alerting on.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.refresh();
  }

  async refresh() {
    const body = new URLSearchParams();
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrf) {
      body.append('authenticity_token', csrf);
    }

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body,
      });

      const html = await response.text();
      window.Turbo.renderStreamMessage(html);

      if (!response.ok) {
        throw new Error('EHR community refresh returned an error');
      }
    } catch (error) {
      window.sendError('EHR community refresh error', error);
    }
  }
}
